// import { updateField } from 'vuex-map-fields'

const SET_REVIEWVALIDATIONS = (state, payload) => {
  state.reviewValidations = payload
}

const SET_REVIEWTYPES = (state, payload) => {
  state.reviewTypes = payload
}

const SET_REVIEW_SCHEDULE_REQUEST = (state, payload) => {
  state.reviewRequest = payload
}

const SET_PRORECORDS_RECORDS = (state, payload) => {
  state.reviewRequest.proRecords.records = payload
}

const SET_AMBULATORYRECORDS_PAYLOAD = (state, payload) => {
  if (!state.reviewRequest.ambulatoryRecords) {
    state.reviewRequest.ambulatoryRecords = {}
  }
  state.reviewRequest.ambulatoryRecords.instructions = payload.instructions
  state.reviewRequest.ambulatoryRecords.chartCount = payload.chartCount
  state.reviewRequest.ambulatoryRecords.records = payload.records
}

const SET_AMBULATORYRECORDS_CLEARED = (state) => {
  if (!state.reviewRequest.ambulatoryRecords) {
    state.reviewRequest.ambulatoryRecords = {}
  }
  state.reviewRequest.ambulatoryRecords.instructions = ''
  state.reviewRequest.ambulatoryRecords.chartCount = 0
  state.reviewRequest.ambulatoryRecords.records = []
}

export default {
  SET_REVIEWVALIDATIONS,
  SET_REVIEW_SCHEDULE_REQUEST,
  SET_PRORECORDS_RECORDS,
  SET_AMBULATORYRECORDS_PAYLOAD,
  SET_AMBULATORYRECORDS_CLEARED,
  SET_REVIEWTYPES
}
